<form clrForm
      [formGroup]="kontaktForm"
      (ngSubmit)="submitForm()">
  <clr-input-container>
    <input clrInput type="hidden" formControlName="cid" />
  </clr-input-container>
  <clr-input-container>
    <label class="clr-col-12 clr-col-md-2">Firma</label>
    <input class="clr-col-12 clr-col-md-10" clrInput type="text" formControlName="company" required />
    <!--<clr-control-helper>Helper text that shows while it is pristine and valid</clr-control-helper>
    <clr-control-error>Error message that appears after focus is lost and control is invalid</clr-control-error>-->
  </clr-input-container>
  <clr-input-container>
    <label class="clr-col-12 clr-col-md-2">Abteilung</label>
    <input class="clr-col-12 clr-col-md-10" clrInput type="text" formControlName="department" />
  </clr-input-container>
  <clr-select-container>
    <label class="clr-col-12 clr-col-md-2">Klassifizierung</label>
    <select class="clr-col-12 clr-col-md-10" clrSelect formControlName="classification" >
      <option value=""></option>
      <option value="S">"S" - Stammlieferant</option>
      <option value="A">"A" Lieferant = ohne Einschränkungen zugelassen für Request und Order</option>
      <option value="B">"B" Lieferant = ohne Einschränkungen für Request zugelassen</option>
      <option value="C">"C" Lieferant = dauerhaft gesperrt für Request und Order</option>
    </select>
  </clr-select-container>
  <clr-input-container>
    <label class="clr-col-12 clr-col-md-2">Straße</label>
    <input class="clr-col-12 clr-col-md-10" clrInput type="text" formControlName="street" required />
  </clr-input-container>
  <clr-input-container>
    <label class="clr-col-12 clr-col-md-2">PLZ</label>
    <input class="clr-col-12 clr-col-md-10" clrInput type="text" formControlName="postcode" required />
  </clr-input-container>
  <clr-input-container>
    <label class="clr-col-12 clr-col-md-2">Ort</label>
    <input class="clr-col-12 clr-col-md-10" clrInput type="text" formControlName="city" required />
  </clr-input-container>
  <clr-select-container>
    <label class="clr-col-12 clr-col-md-2">Bundesland</label>
    <select class="clr-col-12 clr-col-md-10" clrSelect formControlName="region" >
      <option value=""></option>
      <option value="Baden-Württemberg">Baden-Württemberg</option>
      <option value="Bayern">Bayern</option>
      <option value="Berlin">Berlin</option>
      <option value="Brandenburg">Brandenburg</option>
      <option value="Bremen">Bremen</option>
      <option value="Hamburg">Hamburg</option>
      <option value="Hessen">Hessen</option>
      <option value="Mecklenburg-Vorpommern">Mecklenburg-Vorpommern</option>
      <option value="Niedersachsen">Niedersachsen</option>
      <option value="Nordrhein-Westfalen">Nordrhein-Westfalen</option>
      <option value="Rheinland-Pfalz">Rheinland-Pfalz</option>
      <option value="Saarland">Saarland</option>
      <option value="Sachsen">Sachsen</option>
      <option value="Sachsen-Anhalt" selected>Sachsen-Anhalt</option>
      <option value="Schleswig-Holstein">Schleswig-Holstein</option>
      <option value="Thüringen">Thüringen</option>
    </select>
  </clr-select-container>
  <app-country-select controlName="country" label="Land" labelClass="clr-col-12 clr-col-md-2" selectClass="clr-col-12 clr-col-md-10" />
  <clr-input-container>
    <label class="clr-col-12 clr-col-md-2">E-Mail</label>
    <input class="clr-col-12 clr-col-md-10" clrInput type="text" formControlName="email" />
  </clr-input-container>
  <clr-input-container>
    <label class="clr-col-12 clr-col-md-2">Telefon</label>
    <input class="clr-col-12 clr-col-md-10" clrInput type="text" formControlName="phone" />
  </clr-input-container>
  <clr-select-container>
    <label class="clr-col-12 clr-col-md-2">Lieferbedingungen</label>
    <select clrSelect formControlName="cond_delivery">
      <option></option>
      <option *ngFor="let condI of delivery_conditions" value="{{ condI.cond_id }}">{{ condI.name }} ({{ condI.text }})</option>
    </select>
  </clr-select-container>
  <clr-select-container>
    <label class="clr-col-12 clr-col-md-2">Zahlungsbedingungen</label>
    <select clrSelect formControlName="cond_payment">
      <option></option>
      <option *ngFor="let condII of payment_conditions" value="{{ condII.cond_id }}">{{ condII.name }}</option>
    </select>
  </clr-select-container>
  <clr-input-container>
    <label class="clr-col-12 clr-col-md-2">Website</label>
    <input class="clr-col-12 clr-col-md-10" clrInput type="text" formControlName="website" />
  </clr-input-container>
  <clr-input-container>
    <label class="clr-col-12 clr-col-md-2">Steuernummer</label>
    <input class="clr-col-12 clr-col-md-10" clrInput type="text" formControlName="tax_id" />
  </clr-input-container>
  <clr-input-container>
    <label class="clr-col-12 clr-col-md-2">CRM-ID</label>
    <input class="clr-col-12 clr-col-md-10" clrInput type="text" formControlName="crm_id" />
  </clr-input-container>
  <clr-input-container>
    <label class="clr-col-12 clr-col-md-2">USt-IdNr.</label>
    <input class="clr-col-12 clr-col-md-10" clrInput type="text" formControlName="vat_id" />
  </clr-input-container>
  <clr-input-container>
    <label class="clr-col-12 clr-col-md-2">Leitweg-ID (XRechnung)</label>
    <input class="clr-col-12 clr-col-md-10" clrInput type="text" formControlName="leitweg_id" placeholder="z.B. 992-90009-96" />
  </clr-input-container>
  <clr-input-container>
    <label class="clr-col-12 clr-col-md-2">E-Invoice Endpoint</label>
    <input class="clr-col-12 clr-col-md-10" clrInput type="text" formControlName="einvoice_endpoint" placeholder="z.B. e-invoicing@firma.de" />
  </clr-input-container>
  <clr-input-container>
    <label class="clr-col-12 clr-col-md-2">Bankname</label>
    <input class="clr-col-12 clr-col-md-10" clrInput type="text" formControlName="bankname" />
  </clr-input-container>
  <clr-input-container>
    <label for="iban" class="clr-col-12 clr-col-md-2">IBAN</label>
    <input class="clr-col-12 clr-col-md-10 form-control" id="iban" name="iban" clrInput type="text" formControlName="iban" />
    <clr-control-helper *ngIf="iban.valid && (iban.dirty || iban.touched)">IBAN is valid. {{ iban.value | json }}</clr-control-helper>
    <clr-control-error *ngIf="iban.invalid && (iban.dirty || iban.touched)">
      <div *ngIf="iban.errors?.['required']">
        IBAN is required.
      </div>
      <div *ngIf="iban.errors?.['iban']">
        IBAN is invalid!
      </div>
    </clr-control-error>
  </clr-input-container>
  <clr-input-container>
    <label class="clr-col-12 clr-col-md-2">BIC</label>
    <input class="clr-col-12 clr-col-md-10" clrInput type="text" formControlName="bankcode" />
  </clr-input-container>
  <clr-input-container>
    <label class="clr-col-12 clr-col-md-2">Bemerkungen</label>
    <input class="clr-col-12 clr-col-md-10" clrInput type="text" formControlName="notes" />
  </clr-input-container>
  <clr-select-container>
    <label class="clr-col-12 clr-col-md-2">NDA</label>
    <select class="clr-col-12 clr-col-md-10" clrSelect formControlName="nda" >
      <option value="true">ja</option>
      <option value="false">nein</option>
    </select>
  </clr-select-container>
  <clr-select-container>
    <label class="clr-col-12 clr-col-md-2">Status</label>
    <select class="clr-col-12 clr-col-md-10" clrSelect formControlName="active" >
      <option value="true">aktiv</option>
      <option value="false">passiv</option>
    </select>
  </clr-select-container>
  <div>
    <br>
    <button class="btn btn-danger-outline btn-small" type="submit" [disabled]="kontaktForm.invalid">Speichern</button>
    <a class="btn btn-info-outline btn-small" [routerLink]="['/contacts/overview']">Abbrechen</a>
  </div>
</form>

<pre *ngIf="devMode" class="datepicker-output">
    {{ kontaktForm.value | json}}
</pre>
